import 'scss/solutions/zero-trust-remote-access.scss'
import 'babel-polyfill'
import 'js/libs/common'
import 'js/libs/utils-solutions'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min.js'

$(function () {
  var baseSwiper = new Swiper('.swiper-container-base', {
    width: 980,
    pagination: '.swiper-pagination-base',
    paginationClickable: true
  })
  $('.scene-left-tabs li').hover(function (e) {
    var $pagination = $('.swiper-pagination-base')
    $('.scene-left-tabs').find('li.focus').removeClass('focus')
    $pagination.find('.swiper-pagination-bullet').eq($(this).data('eq')).trigger('click')
  }, function () {
    $(this).addClass('focus')
  })
})



// WEBPACK FOOTER //
// ./src/js/entry/solutions/zero-trust-remote-access.js